import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const BrandColor = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 32 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          d="M11.7835 22.9598L17.2859 8.85062C17.3921 8.57831 17.6121 8.36609 17.888 8.26979L25.5138 5.60878C26.042 5.42446 26.6187 5.70934 26.7933 6.24087L29.5298 14.5715C29.6073 14.8076 29.5942 15.064 29.4931 15.2909L23.5885 28.5319C23.3588 29.0469 22.7489 29.2703 22.2409 29.0254L12.2809 24.2239C11.8104 23.9971 11.5937 23.4464 11.7835 22.9598Z"
          fill="var(--blaze-bright-yellow)"
          stroke="var(--neutral-90)"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.48449 15.8598L16.955 3.28686C17.1428 3.09755 17.3984 2.99107 17.665 2.99107L28.5854 2.99088C29.1377 2.99087 29.5854 3.43859 29.5854 3.99088L29.5854 14.9162C29.5854 15.18 29.4812 15.4332 29.2954 15.6205L16.8272 28.191C16.4372 28.5842 15.8018 28.5855 15.4101 28.1939L4.48737 17.2711C4.09798 16.8817 4.09669 16.2508 4.48449 15.8598Z"
          fill="var(--blaze-orange)"
          stroke="var(--neutral-90)"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.3823 9.00547L15.1732 12.2731C14.7174 13.5048 13.7462 14.476 12.5145 14.9318L9.24689 16.1409L12.5145 17.35C13.7462 17.8058 14.7174 18.7769 15.1732 20.0087L16.3823 23.2763L17.5914 20.0087C18.0472 18.7769 19.0184 17.8058 20.2501 17.35L23.5177 16.1409L20.2501 14.9318C19.0184 14.476 18.0472 13.5048 17.5914 12.2731L16.3823 9.00547Z"
          fill="var(--blaze-bright-yellow)"
          stroke="var(--neutral-90)"
        />
        <path
          d="M26.9679 6.79058C26.9679 7.47281 26.4148 8.02586 25.7326 8.02586C25.0504 8.02586 24.4973 7.47281 24.4973 6.79058C24.4973 6.10835 25.0504 5.5553 25.7326 5.5553C26.4148 5.5553 26.9679 6.10835 26.9679 6.79058Z"
          fill="var(--neutral-90)"
        />
      </svg>
    )
  },
)

export default BrandColor
